'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$002dMessage from "./presto.-Agent-View$-Error-Message.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dResponse from "./presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Response.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dResponse from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Response.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dResponse from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Response.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dResponse from "./presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Response.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dResponse from "./presto.-Agent-View$-Local-Shodo-Cert-Chain-Response.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dResponse from "./presto.-Agent-View$-Local-Shodo-Sign-Response.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dResponse from "./presto.-Agent-View$-Upload-File-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$44() {
}
export { $c_Lpresto_AgentView$$anon$44 as $c_Lpresto_AgentView$$anon$44 };
$p = $c_Lpresto_AgentView$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$44;
/** @constructor */
function $h_Lpresto_AgentView$$anon$44() {
}
export { $h_Lpresto_AgentView$$anon$44 as $h_Lpresto_AgentView$$anon$44 };
$h_Lpresto_AgentView$$anon$44.prototype = $p;
$p.cMw = (function(x$0) {
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dError$002dMessage.$c_Lpresto_AgentView$ErrorMessage)) {
    return 0;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dResponse.$c_Lpresto_AgentView$LocalShodoSignResponse)) {
    return 1;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dResponse.$c_Lpresto_AgentView$LocalShodoCertChainResponse)) {
    return 2;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dResponse.$c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse)) {
    return 3;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dResponse.$c_Lpresto_AgentView$LocalPjeOfficeSignFileResponse)) {
    return 4;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dResponse.$c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Response)) {
    return 5;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dResponse.$c_Lpresto_AgentView$LocalPjeOfficeSignHashResponse)) {
    return 6;
  }
  if ((x$0 instanceof $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dResponse.$c_Lpresto_AgentView$UploadFileResponse)) {
    return 7;
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$0);
});
var $d_Lpresto_AgentView$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$44, "presto.AgentView$$anon$44", ({
  E9: 1,
  a: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_AgentView$$anon$44 as $d_Lpresto_AgentView$$anon$44 };
//# sourceMappingURL=presto.-Agent-View$$anon$44.js.map
